import { BoolFilter } from "gen/search/service/service_pb"
import { WebUrl } from "shared-web/lib/webUrl"

export function adminAccounts(): WebUrl {
  return {
    pathname: `/admin/chart-of-accounts/accounts`,
    query: { status: BoolFilter.TRUE.toString() },
  }
}

export function adminMapping(isActive = true): WebUrl {
  return {
    pathname: `/admin/chart-of-accounts/mapping`,
    query: isActive ? { status: BoolFilter.TRUE.toString() } : {},
  }
}
